import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { HelperService, ToasterClass } from 'merlin-core';
import { AuthService, UserService } from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LocalizationService } from '../utilitites/localization.service';
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private helperService: HelperService,
        private msalService: MsalService,
        private userService: UserService,
        private toastrService: ToastrService,
        private readonly injector: Injector,
        private readonly router: Router
    ) { }
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error) => {
                let errorMsg = '';
                if (
                    ([401, 403].indexOf(error?.statusCode) !== -1 ||
                        [401, 403].indexOf(error?.status) !== -1) && error.message?.includes('Please obtain a valid JWT')
                ) {
                    this.logoutUser();
                }


                else if (error.error instanceof ErrorEvent) {
                    console.log('this is client side error');
                    errorMsg = `Error: ${error.error.message}`;
                } else {

                    try {
                            // 401 = invalid NTFYID, 403 = cross-clinic access denied.
                        if ([401, 403].includes(error.status) && error.url?.includes('/transmissions/details')
                            && (window.location.pathname.includes('/patient-list/transmission/summary')
                                || window.location.pathname.includes('/base'))) {
                            return throwError(error);
                        }

                        // MSR metadata errors are handled inline by the component.
                        if (error.url?.includes('/msr/metadata')) {
                            return throwError(error);
                        }

                        const translateService = this.injector.get(TranslateService)
                        const errorMessage = translateService.instant('label.gb.rp_gen_error');

                        if (error?.error?.actionErrors || error?.error?.msgs || error?.error?.messages ||
                            (error?.error?.message && !error.error.message?.includes('Access denied')) || error?.error?.apierror) {
                            return throwError(error);
                        } else {
                            if (error?.error?.message && error.status == 400) {
                                return throwError(error);
                            } else if (error.status == 200) {
                                return throwError(error);
                            }
                            const isLoggedIn = this.isUserLoggedIn();
                            if (isLoggedIn) {
                                console.log('showing toaster for error');
                                this.toastrService.error(errorMessage, null,
                                {
                                    positionClass: 'toastr-top-center',
                                    disableTimeOut: true,
                                    enableHtml: true
                                });
                            } else {
                                this.router.navigate(['/base']);
                            }

                        }
                    } catch {
                        // log without translation translation service is not yet available
                    }

                }
                return throwError(error);
            })
        );
    }

    private logoutUser() {
        this.msalService.logoutRedirect({ postLogoutRedirectUri: environment.logoutRedirectURI });
        window.sessionStorage.clear();
        this.userService.setRoleObs(null);
        this.userService.logoutUser$.next(true);
    }

    private isUserLoggedIn(): boolean {
        return this.msalService.instance.getAllAccounts().length > 0;
    }

}
